"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArrayPattern = exports.isObjectPatternProperty = exports.isObjectPattern = exports.isDestructorExpression = exports.isRangeExpression = exports.isGroupExpression = exports.isExpandOperator = exports.isWildcardOperator = exports.isDotOperator = exports.isIgnoreExpression = exports.isIdentifier = exports.isType = void 0;
exports.isType = function (type) { return function (obj) {
    return obj && obj.type === type;
}; };
exports.isIdentifier = exports.isType('Identifier');
exports.isIgnoreExpression = exports.isType('IgnoreExpression');
exports.isDotOperator = exports.isType('DotOperator');
exports.isWildcardOperator = exports.isType('WildcardOperator');
exports.isExpandOperator = exports.isType('ExpandOperator');
exports.isGroupExpression = exports.isType('GroupExpression');
exports.isRangeExpression = exports.isType('RangeExpression');
exports.isDestructorExpression = exports.isType('DestructorExpression');
exports.isObjectPattern = exports.isType('ObjectPattern');
exports.isObjectPatternProperty = exports.isType('ObjectPatternProperty');
exports.isArrayPattern = exports.isType('ArrayPattern');
